import { FactoryProvider } from '@angular/core';

import { InMemoryStorage, Storage, STORAGE_TOKEN } from '@tablesready/frontend-storage';
import { defaultFieldsOptionsProvider } from './default-fields-options.provider';
import { defaultThemeProvider } from './default-theme.provider';

export * from './default-fields-options.provider';
export * from './default-theme.provider';

export const PROVIDERS: FactoryProvider[] = [
  defaultFieldsOptionsProvider,
  defaultThemeProvider,
  {
    provide: STORAGE_TOKEN,
    useFactory: (): Storage => new InMemoryStorage(),
  },
];
